import React from "react";

const Cube = ({ scaleMultiplier = 50, ...props }) => {
    const dimensions = { ...props.dimensions };
    delete dimensions.weight;
    let baseValue;

    Object.keys(dimensions).forEach((d, index) => {
        // Not a great way to grab baseValue. order not certain
        dimensions[d] = Math.abs(dimensions[d]);

        if (index === 0) {
            baseValue = Number(dimensions[d]);
        }

        const calcSize = (Number(dimensions[d]) / baseValue) * scaleMultiplier;
        dimensions[d] = isNaN(calcSize) ? 0 : calcSize;
    });

    const frontStyles = {
        height: dimensions.height + "px",
        width: dimensions.width + "px",
        lineHeight: dimensions.height + "px",
        transform: `translateZ( ${dimensions.depth / 2}px )`,
    };
    const backStyles = {
        height: dimensions.height + "px",
        width: dimensions.width + "px",
        lineHeight: dimensions.height + "px",
        transform: `rotateX( -180deg ) translateZ( ${dimensions.depth / 2}px )`,
    };
    const leftStyles = {
        height: dimensions.height + "px",
        width: dimensions.depth + "px",
        left: dimensions.depth / 2 + "px",
        lineHeight: dimensions.height + "px",
        transform: `rotateY(  -90deg ) translateZ( ${dimensions.depth}px )`,
    };
    const rightStyles = {
        height: dimensions.height + "px",
        width: dimensions.depth + "px",
        left: -dimensions.depth / 2 + "px",
        lineHeight: dimensions.height + "px",
        transform: `rotateY(   90deg ) translateZ( ${dimensions.width}px )`,
    };
    const topStyles = {
        height: dimensions.depth + "px",
        width: dimensions.width + "px",
        top: dimensions.depth / 2 + "px",
        lineHeight: dimensions.depth + "px",
        transform: `rotateX(  90deg ) translateZ( ${dimensions.depth}px )`,
    };
    const bottomStyles = {
        height: dimensions.depth + "px",
        width: dimensions.width + "px",
        top: dimensions.height + "px",
        lineHeight: dimensions.depth + "px",
        transform: `rotateX(  -90deg ) translateZ( ${dimensions.depth / -2}px )`,
    };

    const cubeClass = props.isMatch ? "cube -selected" : "cube";

    return (
        <div className="cube-container">
            <div className={cubeClass}>
                <div className="front" style={frontStyles}></div>
                <div className="back" style={backStyles}></div>
                <div className="top" style={topStyles}></div>
                <div className="bottom" style={bottomStyles}></div>
                <div className="left" style={leftStyles}></div>
                <div className="right" style={rightStyles}></div>
            </div>
        </div>
    );
};

export default Cube;
